module.exports = __webpack_public_path__ + "img/camera.b78089b3.svg";